import { memo } from "react";
import { Box, Stack, Typography, LinearProgress } from "@mui/material";
import { ITopMerchant } from "../../../interfaces/dashboard";
import { formatNumber } from "../../../utils/metricsFormatters";

interface ITopMerchantsProps {
  data: ITopMerchant[];
}

const BAR_COLOR = "#1565c0";

// Ranking con barra relativa bajo cada nombre (B1): el 100% equivale al merchant
// con más órdenes (el primero, ya que el backend ordena desc por count).
const TopMerchants = ({ data }: ITopMerchantsProps) => {
  const maxCount = data.reduce((max, item) => Math.max(max, item.count), 0);

  return (
    <Stack spacing={1.5}>
      {data.map((item, index) => {
        const relative = maxCount === 0 ? 0 : (item.count / maxCount) * 100;
        return (
          <Box key={item.merchantName || `merchant-${index}`}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={0.5}
            >
              <Typography variant="body2" color="text.primary" noWrap>
                {`${index + 1}. ${item.merchantName || "Sin nombre"}`}
              </Typography>
              <Typography variant="body2" fontWeight={600} color="text.primary">
                {formatNumber(item.count)}
              </Typography>
            </Box>
            <LinearProgress
              variant="determinate"
              value={relative}
              sx={{
                height: 6,
                borderRadius: 1,
                backgroundColor: "#eceff1",
                "& .MuiLinearProgress-bar": { backgroundColor: BAR_COLOR },
              }}
            />
          </Box>
        );
      })}
    </Stack>
  );
};

export default memo(TopMerchants);
